import { Component } from 'preact';
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";
import { E_DeliveryWizard_Section } from "../../models/constants/Enums_DeliveryWizard";
import DeliveryWizardPartner from "./sections/DeliveryWizardPartner";
import withConfiguration from "../../components/shared/hoc/withConfiguration";
import DeliveryWizardUser from "./sections/DeliveryWizardUser";
import { route } from "preact-router";
import { E_Route } from "../../models/constants/Enum_Routes";
import { AppUtils } from "../../utils/AppUtils";
import DeliveryWizardBoxType from "./sections/DeliveryWizardBoxType";
import DeliveryWizardSummary from "./sections/DeliveryWizardSummary";

class DeliveryWizard extends Component {
	constructor() {
		super();

		this.state = {
			selectedPartner: null,
			selectedUser: null,
			customUserEmail: null,
			selectedServiceType: null,
		}
	}

	componentDidMount() {
		if(AppUtils.isProduction) {
			if(window.location.pathname !== E_Route.DELIVERY_WIZARD(E_DeliveryWizard_Section.PARTNER_SELECT)) {
				route(E_Route.DELIVERY_WIZARD(E_DeliveryWizard_Section.PARTNER_SELECT));
			}
		}
	}

	_renderSection() {
		const {section, configuration} = this.props;
		const {selectedPartner, selectedUser, customUserEmail, selectedServiceType} = this.state;

		switch (section) {
			case E_DeliveryWizard_Section.PARTNER_SELECT:
				return (
					<DeliveryWizardPartner
						locationID={configuration.locationID}
						selectedPartner={selectedPartner}

						onContinue={partner => this._handlePartnerSelection(partner)}
					/>
				);
			case E_DeliveryWizard_Section.USER_SELECT:
				return (
					<DeliveryWizardUser
						locationID={configuration.locationID}
						partnerID={selectedPartner?.id}
						selectedUser={selectedUser}
						customUserEmail={customUserEmail}

						onContinue={(selectedUser, customUserEmail) => this._handleUserSelection(selectedUser, customUserEmail)}
					/>
				)
			case E_DeliveryWizard_Section.BOX_TYPE:
				return <DeliveryWizardBoxType
					locationID={configuration.locationID}
					unitID={configuration.unitID}
					partnerID={selectedPartner?.id}
					selectedServiceType={selectedServiceType}

					onContinue={(selectedServiceType) => this._handleServiceTypeSelection(selectedServiceType)}
				/>
			case E_DeliveryWizard_Section.SUMMARY:
				return (
					<DeliveryWizardSummary
						locationID={configuration.locationID}
						unitID={configuration.unitID}
						partner={selectedPartner}
						serviceType={selectedServiceType}
						user={selectedUser}
						customUserEmail={customUserEmail}
					/>
				)
		}
	}

	render({className, style}, {}) {
		return (
			<section className={combineClasses("delivery-wizard", className)} style={style}>
				{this._renderSection()}
			</section>
		);
	}

	_handlePartnerSelection(partner) {
		const {configuration} = this.props;

		this.setState({selectedPartner: partner});

		if(configuration.allowDeliveryUserSelection) {
			route(E_Route.DELIVERY_WIZARD(E_DeliveryWizard_Section.USER_SELECT));
		}
		else {
			route(E_Route.DELIVERY_WIZARD(E_DeliveryWizard_Section.BOX_TYPE));
		}
	}

	_handleUserSelection(selectedUser, customUserEmail) {
		this.setState({selectedUser, customUserEmail});

		route(E_Route.DELIVERY_WIZARD(E_DeliveryWizard_Section.BOX_TYPE));
	}

	_handleServiceTypeSelection(selectedServiceType) {
		this.setState({selectedServiceType});

		route(E_Route.DELIVERY_WIZARD(E_DeliveryWizard_Section.SUMMARY));
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			section: PropTypes.oneOf(Object.values(E_DeliveryWizard_Section)),

			//withConfiguration
			configuration: PropTypes.object,
		}
	}

	static get defaultProps() {
		return {
			section: E_DeliveryWizard_Section.PARTNER_SELECT,
		}
	}
}

export default withConfiguration(DeliveryWizard);
